import { queryCache } from '@office-start/data-fetching';
import { licenseStatusQueryKeyPreFix } from './models/constants';
import { getLicenseStatusFromShellService } from './operations/getLicenseStatusFromShellService';
var getQueryKey = function (app) {
    return licenseStatusQueryKeyPreFix + app.toLocaleLowerCase();
};
export function fetchLicenseStatus(app, scenarioId) {
    var queryKey = getQueryKey(app);
    return queryCache.fetchQuery(queryKey, function () { return getLicenseStatusFromShellService(app, scenarioId); }, {
        staleTime: Infinity,
        cacheTime: Infinity,
    });
}
//# sourceMappingURL=fetchLicenseStatus.js.map